var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargedBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_291_323)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_291_323",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_291_323",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_291_323",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACgUlEQVR4nO3cT6hMYRjH8S9CKCVRujZ2lFL+FAsLStlZTVlQFmIjCxtsKAs3pWwkOxuRWyyVW3Z2snN31L0bsfCnKCnu1anRnO6Yd3jf95w5c+73U+/u9DTz/M5zznvu3BmQJEmSJEmSJEmSJEmStEQsA/YCl4HbwJSLPz24B1wDjgFrqg5iOXACeAssuBjWg2/ADWBDFWEURacNgZgT8R2wP3cYM4ZBylXhO3A412XKySDLJfojsC01kJNOBjnvl09Sd1PewMm+gdkdG8i+QNF54C6wA1iRknrLbAHOAp8DvZuMLX4pULQIQ4Md6Z60f+vdSyLdCQSyPbboEjIzoHcfYgs+CgTiZWq4x4HLfZSpQCAaQf8MpAWBbAU6DV4HYptRU/+yF+xUsG9fyLiK91QXA8FAnJAAJ4TxnJDycT+7zy+nUgqWeQ9JC6S8+kIxkNEG8jq2YJkTki+Q4vL1TwcaSD2B9PXZQNIYCOO/y3JCKmQgOCF93GX1OCE4IX2ckB4nBCekjxOSb0K+LjrOB8MRBzIdW7DMCckTyCdg56LjDKSmQC6UvvD0ELgKTKQULHNCevzEkPHcZVVa0AlpWCDqMZCGMZC2B3I/UHBd3tfeSk8H9O5HbMGbgUAO5X3trbMSeD+gd7OxRc8EAnkFrM/7HlplMtC7Z7FFJwJfyyrWXPep8ngD/qu905B1Hng+5FnoXBXXQRdRPSj+grs5JZBdwC8DINcJeIUMLhoIOcJ4Aawmk1uGQkoYxSZoE5mdBr4YDP8TxHz3N7TWUpGNwHXgjcEQCqI4cR8Ae6hR8cs2Bxuw1ew0aB3tftK3qs4gJEmSJEmSJEmSJEmSJEmSSPYbxO4j3fXEir8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargedBattery);
export default __webpack_public_path__ + "static/media/Charged Battery.9c699c913732063bb826dea6bd6ab722.svg";
export { ForwardRef as ReactComponent };